import { useMutation } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import { parseFilenameFromDisposition, triggerBlobDownload } from '@/libs/download';

const downloadMentionMedia = async (mentionId: string): Promise<void> => {
  const response = await api.get(`/dashboard/mentions/${mentionId}/media/download`, {
    responseType: 'blob',
  });

  const disposition =
    (response.headers['content-disposition'] as string | undefined) ||
    (response.headers['Content-Disposition'] as string | undefined);
  const filename = parseFilenameFromDisposition(disposition) ?? `mention_${mentionId}.jpg`;

  triggerBlobDownload(response.data, filename);
};

/**
 * React Query mutation hook for downloading mention media
 * @returns Mutation object with download functionality
 */
export const useDownloadMentionMediaMutation = () => {
  return useMutation({
    mutationFn: downloadMentionMedia,
  });
};
